import React, { useState } from "react";
import { View, Text, Pressable } from "react-native";
import styles from "../../../Styles/RegistryStyles";
import { REGISTRY_SETUP_STAGES } from "../../../constants/RegistrySetupStages";
import Catalogue from "../Catalogue";
import RegistryStarterChoices from "./RegistryStarterChoices";
import RegistryStarterItems from "./RegistryStarterItems";
import RegistryAddSuccess from "./RegistryAddSuccess";
import { useSpotlightSignals } from "../../../Widgets/SpotlightTutorial/spotlightBus";
import { SPOTLIGHT_SIGNAL_SCOPES } from "../../../Widgets/SpotlightTutorial/spotlightEventNames";
import { SPOTLIGHT_TARGETS, spotlightTarget } from "../../../Widgets/SpotlightTutorial/spotlightTargets";

const HIDDEN_STYLE = { display: "none" };

/**
 * Browse Catalogue entry point: pick a starter list or the full catalogue, then confirm the items were added.
 * Only one of these views is visible at a time. The catalogue stays mounted once opened (just hidden),
 * so "Add More Items" returns to it exactly where the user left off.
 */
const RegistrySetupFlow = ({ onAddItems, onClose }) => {
	const [stage, setStage] = useState(REGISTRY_SETUP_STAGES.CHOOSE);
	const [template, setTemplate] = useState(null);
	const [hasOpenedCatalogue, setHasOpenedCatalogue] = useState(false);

	useSpotlightSignals(SPOTLIGHT_SIGNAL_SCOPES.REGISTRY, { setupStage: stage });

	const openCatalogue = () => {
		setHasOpenedCatalogue(true);
		setStage(REGISTRY_SETUP_STAGES.CATALOGUE);
	};

	const selectTemplate = (selectedTemplate) => {
		setTemplate(selectedTemplate);
		setStage(REGISTRY_SETUP_STAGES.STARTER);
	};

	const addItems = async (items) => {
		const wasAdded = await onAddItems(items);
		if (wasAdded) setStage(REGISTRY_SETUP_STAGES.SUCCESS);
		return wasAdded;
	};

	return (
		<View style={styles.blurredContainer}>
			{hasOpenedCatalogue && (
				<View
					style={[styles.catalogueModalContent, stage !== REGISTRY_SETUP_STAGES.CATALOGUE && HIDDEN_STYLE]}
					{...spotlightTarget(SPOTLIGHT_TARGETS.REGISTRY_CATALOGUE_MODAL)}
				>
					<View style={styles.catalogueModalHeader}>
						<Pressable style={styles.catalogueCloseButton} onPress={onClose}>
							<Text style={styles.backButtonText}>X</Text>
						</Pressable>
						<Text style={styles.catalogueModalTitle}>Catalogue Items</Text>
					</View>
					<View style={styles.catalogueContainer}>
						<Catalogue isFromRegistry={true} onAddItems={addItems} />
					</View>
				</View>
			)}
			{stage === REGISTRY_SETUP_STAGES.CHOOSE && <RegistryStarterChoices onSelectTemplate={selectTemplate} onBuildOwn={openCatalogue} onClose={onClose} />}
			{stage === REGISTRY_SETUP_STAGES.STARTER && (
				<RegistryStarterItems template={template} onBack={() => setStage(REGISTRY_SETUP_STAGES.CHOOSE)} onAddItems={addItems} onClose={onClose} />
			)}
			{stage === REGISTRY_SETUP_STAGES.SUCCESS && <RegistryAddSuccess onAddMore={openCatalogue} onDone={onClose} />}
		</View>
	);
};

export default RegistrySetupFlow;
